var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0166 8.67032H14.6745V6.88091C14.6745 3.42753 11.8651 0.618042 8.41165 0.618042C4.95823 0.618042 2.14878 3.42753 2.14878 6.88091V8.67032H0.806738C0.559466 8.67032 0.359375 8.87041 0.359375 9.11768V20.3014C0.359375 21.2883 1.16188 22.0908 2.14878 22.0908H14.6746C15.6614 22.0908 16.4639 21.2883 16.4639 20.3014V9.11768C16.4639 8.87041 16.2638 8.67032 16.0166 8.67032ZM9.7511 18.0153C9.76506 18.1415 9.72447 18.2682 9.63971 18.363C9.55495 18.4578 9.43349 18.512 9.30638 18.512H7.51697C7.38985 18.512 7.2684 18.4578 7.18364 18.363C7.09888 18.2683 7.05824 18.1416 7.07225 18.0153L7.35446 15.4776C6.89619 15.1442 6.62229 14.6169 6.62229 14.0385C6.62229 13.0516 7.42479 12.2491 8.41169 12.2491C9.3986 12.2491 10.2011 13.0516 10.2011 14.0385C10.2011 14.6169 9.9272 15.1442 9.46893 15.4776L9.7511 18.0153ZM4.83288 6.88091V8.67032H11.9904V6.88091C11.9904 4.9076 10.385 3.30213 8.41165 3.30213C6.43834 3.30213 4.83288 4.9076 4.83288 6.88091Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4e50f6c313164d717b66df859e5347af.svg";
export { ForwardRef as ReactComponent };